var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"centered-box"},[_vm._t("default"),_c('div',{staticClass:"centered-box__child",style:({ top: ("calc(50% + " + _vm.offsetY + "px)") })},[_vm._t("child")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }